import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import * as Sentry from "@sentry/react";

import AppErrorFallback from "./common/components/AppErrorFallback";
import Login from "./pages/Login";
import NewLogin from "./pages/NewLogin";
import NewLoginV2 from "./pages/NewLoginV2";
import ForgotPassword from "./pages/ForgotPassword";
import SetPassword from "./pages/SetPassword";
import AppRedirect from "./pages/AppRedirect";
import FamilyConsent from "./pages/familymember/FamilyConsent";
import "./styles/familymember.css";
import { caregiverRoutes } from "./pages/caregiver/caregiverRoutes";
import { familyMemberRoutes } from "./pages/familymember/familymemberRoutes";
import { resolveSessionLandingRoute } from "./common/utils/authSession";

import PrivateRoute from "./PrivateRoutes";

const RootRedirect = () => {
  return <Navigate to={resolveSessionLandingRoute()} replace />;
};

function RoutesSetting() {
  const privateRoutes = [...caregiverRoutes, ...familyMemberRoutes];

  return (
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}>
      <Sentry.ErrorBoundary fallback={<AppErrorFallback />}>
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/login" element={<NewLoginV2 />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/set-password" element={<SetPassword />} />
          <Route path="/app" element={<AppRedirect />} />
          <Route path="/family-agreement-preview" element={<FamilyConsent />} />
          {privateRoutes.map(({ path, element }) => (
            <Route key={path} path={path} element={<PrivateRoute>{element}</PrivateRoute>} />
          ))}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Sentry.ErrorBoundary>
    </BrowserRouter>
  );
}

export default RoutesSetting;
